// extracted by mini-css-extract-plugin
export var container = "forum-module--container--c03cc";
export var content = "forum-module--content--789b9";
export var list = "forum-module--list--16628";
export var listBox = "forum-module--list-box--3f66f";
export var listTitle = "forum-module--list-title--0c9c6";
export var loader = "forum-module--loader--2f4b5";
export var message = "forum-module--message--571cf";